import React, { useState } from 'react';

import { Control, Controller, FieldName, FieldValues, UseControllerOptions } from 'react-hook-form';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

type InputProps<T extends FieldValues> = UseControllerOptions & {
  control: Control<T>;
  label?: string;
  name: FieldName<T>;
};

export const FormCheckbox = <T extends FieldValues>({ control, label, name }: InputProps<T>) => {
  const [isChecked, setIsChecked] = useState<boolean>(control.defaultValuesRef.current[name]);

  const handleChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setIsChecked(checked);
    control.setValue(name, checked, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <Controller
      name={name}
      control={control}
      render={(fields) => (
        <FormControlLabel
          control={<Checkbox {...fields} checked={isChecked} onChange={handleChange} />}
          label={label}
        />
      )}
    />
  );
};
